<template>
  <div>

    <div class="container-fluid bg-white py-3">
      <div class="row">
        <div class="col-12">
          <h1 class="mb-0">Add a Property</h1>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row mk-businesspropertyinformation pt-3 mt-4">
        <div class="col-12 col-md-6 bg-white mx-auto pt-5 pb-3 d-flex justify-content-between align-items-center">
          <h2>Property Details</h2>
          <p class="mb-0">Step 2</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 bg-white mx-auto py-3">
          <hr />
        </div>
      </div>
 
      <div class="row justify-content-center">
        <div class="col-12 col-md-6 mx-auto bg-white py-3">

          <el-form
            :model="property"
            label-position="left"
            v-for="(property, index) in business.properties"
            :key="index"
            :rules="rules"
            ref="property-forms"
            label-width="120px"
            class="w-100 mx-auto row flex-column justify-content-center"
          >
            <el-form-item label="PIC" prop="pic">
              <el-input v-model="property.pic"></el-input>
            </el-form-item>

            <el-form-item label="Property Name" prop="name">
              <el-input v-model="property.name"></el-input>
            </el-form-item>

            <el-form-item label="Address" prop="address">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="form-group col-12">
                      <google-maps-autocomplete
                        class="form-control"
                        :value="property.address"
                        v-on:address-components="saveAddresses($event, property)"
                        @coordinates="saveCoordinates($event, property)"
                        placeholder="10 Street Name"/>
                    </div>
                    <div v-if="property.lng && property.lat" class="form-group mt-0 col-12 d-flex justify-content-around">
                      <span>Lng: {{ property.lng }}</span>
                      <span>Lat: {{ property.lat }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>

            <div class="row">
              <div class="col-2">
              </div>
              <div class="col-10">
                <button class="btn btn-link" @click.prevent="mapsTrigger[index].openMap = !mapsTrigger[index].openMap">Open Maps</button>
                <draggable-map
                  v-show="mapsTrigger[index].openMap"
                  @dropped-pin="useLocation($event, property)"
                  autocomplete-placeholder="Find an address"
                  :longtitude="Number(property.lng) || undefined"
                  :latitude="Number(property.lat) || undefined"
                />
              </div>
            </div>

            <el-form-item label="Owning Entity" prop="owning_entity">
              <el-input v-model="property.owning_entity"></el-input>
            </el-form-item>

            <el-form-item label="Legal Name of Person PIC is registered to" prop="owner_legal_name">
              <el-input v-model="property.owner_legal_name"></el-input>
            </el-form-item>

            <el-form-item label="Regions" prop="region_id">
              <!-- <el-input v-model="property.region_id"></el-input> -->
              <el-select
                class="input-group"
                v-model="property.region_id"
                placeholder="Select Region"
                clearable>
                <el-option
                  v-for="region in regions"
                  :key="region.id"
                  :label="region.region"
                  :value="region.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Cattle Average Daily Gain" prop="cattle_average_daily_gain">
              <el-input v-model="property.cattle_average_daily_gain" type="number"></el-input>
            </el-form-item>

            <el-form-item label="Sheep Average Daily Gain" prop="sheep_average_daily_gain">
              <el-input v-model="property.sheep_average_daily_gain" type="number"></el-input>
            </el-form-item>

            <el-form-item label="PIC Category" prop="pic_category_id">
              <!-- <el-input v-model="property.region_id"></el-input> -->
              <el-select
                class="input-group"
                v-model="property.pic_category_id"
                placeholder="Select PIC Category"
                clearable>
                <el-option
                  v-for="category in picCategories"
                  :key="category.id"
                  :label="category.name"
                  :value="category.id">
                </el-option> 
              </el-select>
            </el-form-item>

            <el-form-item label="PIC Certifications" prop="certification_ids">
              <!-- <el-input v-model="property.region_id"></el-input> -->
              <el-select
                class="input-group"
                v-model="property.certification_ids"
                placeholder="Select PIC Category"
                clearable
                multiple>
                <el-option
                  v-for="certification in picCertifications"
                  :key="certification.id"
                  :label="certification.name"
                  :value="certification.id">
                </el-option> 
              </el-select>
            </el-form-item>

            <div class="row">
              <div class="col-12">
                <hr />
              </div>
            </div>
          </el-form>



          <div class="row justify-content-center">
            <div class="form-group col-12 d-flex">
              <el-button type="primary" class="mr-auto btn-light-blue" plain @click="onAdd">
                <i class="fas fa-plus mr-2"></i> Add Property
              </el-button>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-12">
              <hr />
            </div>
          </div>

          <div class="form-group row justify-content-center">
            <div class="col-12 d-flex justify-content-between align-items-center">
              <el-button
                class="btn-light-blue"
                @click="onPrevious"
                plain
              >Back</el-button>

              <div>
                <el-button
                  class="btn-light-blue"
                  @click="onSubmitDraft"
                  plain
                >Save as Draft</el-button>

                <el-button
                  class="btn-blue"
                  @click="onSubmit"
                  type="primary"
                >Save and Submit</el-button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


  </div>
</template>




<script>
import Business from "../../../models/Business";

export default {
  props: {
    initial_business: {
      type: Business
    },
    regions: {
      type: Array
    },
    picCategories: {
      type: Array
    },
    picCertifications:{
      type: Array
    }
  },
  data() {
    return {
      //
      business: this.initial_business,
      rules: {
        name: [
          {
            required: true,
            message: "Please choose a name",
            trigger: "blur"
          }
        ],
        pic: [
          {
            required: true,
            message: "Please choose a PIC",
            trigger: "blur"
          }
        ]
      },
      mapsTrigger: [
        { openMap: false }
      ]
    };
  },
  methods: {
    saveAddresses(payload, target) {
      target.extra_attributes.address = payload;
      target.extra_attributes.address.name = payload.formatted_address;
      target.address = payload.formatted_address;
      target.extra_attributes.address.formatted_address = payload.formatted_address;
    },
    saveCoordinates(payload, target) {
      target.lat = payload.lat;
      target.lng = payload.lng;
    },
    useLocation(value, target){
      target.address = value.google_address.formatted_address;
      target.extra_attributes.address.formatted_address = value.google_address.formatted_address;
      target.extra_attributes.address.lat = value.location.lat;
      target.extra_attributes.address.lng = value.location.lng;

      target.lat = value.location.lat;
      target.lng = value.location.lng;

      value.google_address.address_components.forEach(x => {
        let type = x.types[0];
        target.extra_attributes.address[type] = x.short_name;
      });

      if(value.google_address.address_components[0].types.find(type => type == 'subpremise')) {
        target.extra_attributes.address.unit_number = value.google_address.address_components[0].short_name;
      }
    },
    onAdd() {
      this.mapsTrigger.push({ openMap: false });
      this.business.properties.push({ 
        extra_attributes: { address: {} },
        lng: '',
        lat: ''
      });
    },
    onSubmit() {
      let passes = true;

      for (let i = 0; i < this.$refs["property-forms"].length; i++) {
        this.$refs["property-forms"][i].validate(valid => {
          if (!valid) {
            passes = false;
          }
        });
      }

      if (passes) {
        this.$emit("submit", this.business);
      } else {
        this.$message({
          type: "error",
          message: "Looks like there was some invalid data."
        });
      }
    },
    onPrevious() {
      this.$emit("previous", this.business);
    },
    onSubmitDraft() {
      this.$emit("draft", this.business);
    },
  }
};
</script>